import { ShoppingCart } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router";
import { useCart } from "@nusrif/contexts";

export const CartButton = () => {
  const navigate = useNavigate();
  const { state } = useCart();
  
  const itemCount = state.cart ? state.cart.lines.reduce((sum, line) => sum + line.quantity, 0) : 0;
  
  const handleCartClick = () => {
    navigate('/cart');
  };

  return (
    <Button
      size="sm"
      className="relative w-10 h-10 rounded-full bg-primary text-white p-0"
      onClick={handleCartClick}
    >
      <ShoppingCart className="w-5 h-5" />
      {itemCount > 0 && (
        <div className="absolute -top-2 -right-2 w-5 h-5 bg-secondary-yellow rounded-full flex items-center justify-center">
          <span className="text-xs font-bold text-tertiary-navy">
            {itemCount > 99 ? '99+' : itemCount}
          </span>
        </div>
      )}
    </Button>
  );
};